import { Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { TitleBar } from '../../components/TitleBar';
import { createActivity } from '../../models/activities';
import { getActivity, RootState, useAppDispatch, useAppSelector } from '../../redux';
import { MyBoxModal } from '../../styled-components';
import { SubActivities } from '../subActivities';
import { MyForm } from './components';

export const ActivityItems = () => {
    const { id } = useParams();

    const dispatch = useAppDispatch();
    const { isLoading, activity } = useAppSelector((state: RootState) => state.activities);

    useEffect(() => {
        if (id)
            dispatch(getActivity(id));
    }, [dispatch, id]);

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);
    const [editing, setEditing] = useState(false);
    const [activityToEdit, setActivityToEdit] = useState(createActivity({}));
    const onEdit = () => {
        setActivityToEdit(createActivity(activity));
        setEditing(true);
        openDialog();
    }

    return (
        <div>
            <Loading isLoading={isLoading} />
            <TitleBar onEdit={onEdit} title={activity.name} urlToBack='/activities/' />
            <br />
            <Typography variant="h6" component="h2">Sub Activities</Typography>
            <br />
            <SubActivities isToAddSubActivities={true} idActivity={id} />
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} activity={activityToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
        </div >
    );
}
